import { getHighlightColors } from "@karda/design-tokens";
import { env } from "./config/env";

export const EASTER_EGGS = [
  "remove me",
  "blue elephant",
  "take this off",
  "easter egg",
  "flying monkey",
  "golden key",
  "secret handshake",
  "hidden staircase",
  "starry night",
  "red panda",
  "ghost bicycle",
  "velvet fox",
  "glowing turtle",
  "android cat",
  "paper rocket",
  "mystery llama",
  "whispering willow",
  "sapphire comet",
  "ginger cloud",
  "copper canoe",
  "lone mariner",
  "dancing otter",
  "clockwork crow",
  "brass unicorn",
  "neon narwhal",
  "polka dot seal",
  "maple detective",
  "lantern librarian",
  "silver coyote",
  "orchid robot",
  "tiny atlas",
  "royal pebble",
  "patchwork raven",
  "midnight wagon",
  "meadow mime",
  "peanut astronaut",
  "marshmallow judge",
  "cobalt kite",
  "sunglass ghost",
  "paperclip wizard",
  "olive penguin",
  "plaid comet",
  "quartz squirrel",
  "cinnamon cipher",
  "firefly taxi",
  "lunar marmot",
  "bronze biscuit",
  "velvet compass",
  "stardust hermit",
  "mosaic seagull",
  "crimson ledger",
  "whale postcard",
  "moonbeam tailor",
  "beacon gardener",
  "pocket bison",
  "frosted gondola",
  "cobalt whisper",
  "gingerbread anchor",
  "opal spatula",
  "tangerine lighthouse",
];

// Light-mode set; dark variants via getHighlightColors("dark") from the tokens package.
export const HIGHLIGHT_COLORS = getHighlightColors("light");

export const EFORCE_MODEL_COLOR_MAP = [
  "Classifications",
  "Properties",
  "Narratives",
  "Victims",
  "Suspects",
  "OtherInvolved",
  "Vehicles",
  "Businesses",
].reduce<Record<string, string>>((acc, key, index) => {
  acc[key] = HIGHLIGHT_COLORS[index];
  return acc;
}, {});

export const COMMAND_STAFF_ROLES = [
  "COMMANDER",
  "CORPORAL",
  "MAJOR",
  "SERGEANT",
  "LIEUTENANT",
  "CAPTAIN",
  "DEPUTY CHIEF",
  "CHIEF",
];

export const AGENT_API_BASE_URL = env.api.agent;